import React, { Component } from 'react'
import { Breadcrumb, Card, Layout, Modal, Progress, Row, Tabs } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import { strVal } from '../../../modules/Utils'
import FooterButton from '../../../elements/Buttons/FooterButtons'
import ProgramForm from '../../../components/Project/Programs/ProgramForm'
import { get } from 'lodash'
import List from '../../../components/Project/Programs/List'
import style from '../../../components/Sales/Payments/style.css'
import ProjectList from '../../../components/Project/Projects/List'

const TabPane = Tabs.TabPane

const { Content } = Layout

class ProgramsListView extends Component {
  columnsAllProject = [
    {
      Header: 'Code',
      accessor: 'code',
      zIndex: -10,
      Cell: ({ value, original }) => {
        return (
          <Link
            to={
              `/programs/` +
              `${strVal(original, 'ancestors[0].id').replace('projects/', '')}` +
              `/projects/${strVal(original, '_key').replace('projects/', '')}/view`
            }>
            {value}
          </Link>
        )
      },
    },
    {
      Header: 'Title',
      accessor: 'project.title',
      zIndex: -9,
    },
    {
      Header: 'Program Title',
      accessor: 'ancestors[0].title',
    },
    {
      Header: 'Program code',
      accessor: 'ancestors[0].code',
      Cell: ({ value, original }) => {
        return <Link to={`/program/${strVal(original, 'ancestors[0].id').replace('projects/', '')}`}>{value}</Link>
      },
    },
    {
      Header: 'Type',
      accessor: 'project.projectType',
    },
    {
      Header: 'Category',
      accessor: 'project.category',
    },
    {
      Header: 'Project Manager',
      accessor: 'project.projectManager.fn',
    },
    {
      Header: 'Status',
      accessor: 'status',
      zIndex: 999,
    },
    {
      Header: 'Company',
      accessor: 'project.category',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Company',
      accessor: 'project.company.fn',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Cost Center',
      accessor: 'project.cost._id[0]',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Department',
      accessor: 'project.department',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Start Dates',
      accessor: 'project.startDate',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'End Date',
      accessor: 'project.endDate',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Completion',
      accessor: 'completion',
      Cell: ({ value }) => {
        const progressColor = value > 40 && value < 100 ? '#154DE1' : value === 100 ? '#15E16F' : '#E13915'
        return <Progress percent={value} size="small" strokeColor={progressColor} />
      },
    },
  ]

  render() {
    const {
      onCancel,
      submit,
      submitting,
      remove,
      removing,
      update,
      modalType,
      visible,
      formRef,
      fetchProjects,
      fetchingProject,
      listProject,
    } = this.props

    return (
      <Content style={{ margin: '0px 0px' }}>
        <Modal
          title={'Program'}
          visible={visible}
          destroyOnClose={true}
          confirmLoading={submitting}
          onCancel={onCancel}
          width={'45%'}
          footer={
            <FooterButton
              isEdit={modalType === 'edit'}
              isNew={modalType === 'new'}
              remove={remove}
              removing={removing}
              submit={submit}
              submitting={submitting}
              update={update}
              title={'Program'}
            />
          }>
          <ProgramForm {...this.props} ref={formRef} />
        </Modal>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Programs</Breadcrumb.Item>
            </Breadcrumb>
            <h1 className={style.title}>Programs</h1>
            <p className={style.paragraph}>View and list programs.</p>
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Tabs
              defaultActiveKey={get(this.props, 'location.hash') || '#programs'}
              onChange={(key) => this.props.history.push(key)}>
              <TabPane tab="Programs" key="#programs">
                <List {...this.props} />
              </TabPane>
              <TabPane tab="All Projects" key="#projects">
                <ProjectList list={listProject} fetch={fetchProjects} fetching={fetchingProject} />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    )
  }
}

export default withRouter(ProgramsListView)
